import { AppEnvironment } from './environment.model';

// Development Firebase web app config placeholders.
// Use the same values as production unless you keep a separate Firebase project for development.
export const environment: AppEnvironment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDYc0-zoxgbcss8KkP6iT5XqClw1hZeG7k",
    authDomain: "yeshua-college-dev.firebaseapp.com",
    projectId: "yeshua-college-dev",
    storageBucket: "yeshua-college-dev.firebasestorage.app",
    messagingSenderId: "342961208165",
    appId: "1:342961208165:web:ec294c3d5a572b2f5dff8c",
    measurementId: "G-FCRZ63QSTZ"
  }
};
